export default __webpack_public_path__ + "5e15b0f2ba915a1b67d8fcdf09860e15.svg";